import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import client, { formatError } from "@/lib/apiClient";

const AuthContext = createContext(null);

export const DEMO_ACCOUNTS = [
  { role: "owner", email: "hisham8@gmail.com", label_ar: "المالك", label_en: "Owner", icon: "crown" },
  { role: "manager", email: "manager@madarek.sa", label_ar: "مدير الفندق", label_en: "Hotel Manager", icon: "briefcase" },
  { role: "housekeeping", email: "staff@madarek.sa", label_ar: "طاقم التدبير", label_en: "Staff", icon: "brush-cleaning" },
  { role: "guest", email: "guest@madarek.sa", label_ar: "ضيف", label_en: "Guest", icon: "bed-single" },
  { role: "super_admin", email: "admin@madarek.sa", label_ar: "إدارة النظام", label_en: "Super Admin", icon: "shield" },
];
const DEMO_PASSWORD = "Madarek@123";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("md_token");
    if (!token) { setLoading(false); return; }
    client.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("md_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await client.post("/auth/login", { email, password });
    localStorage.setItem("md_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const loginAs = useCallback(async (email) => {
    const { data } = await client.post("/auth/login", { email, password: DEMO_PASSWORD });
    localStorage.setItem("md_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("md_token");
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, loginAs, logout, formatError }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
